import { ComponentProps } from 'react';
import { Checkbox, Field, FieldDescription, FieldError, FieldLabel } from '@utilities-one/gpm-ui';

import { useFieldContext } from '@/library/form/contexts';
import { FormControlProps } from '@/library/form/types/form.type';

type FormCheckboxProps = FormControlProps & {
  checkboxProps?: ComponentProps<typeof Checkbox>;
};

export function FormCheckbox({ label, description, hint, checkboxProps }: FormCheckboxProps) {
  const field = useFieldContext<boolean>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <Field data-invalid={isInvalid}>
      <div className="flex items-center gap-2">
        <Checkbox
          {...checkboxProps}
          id={field.name}
          name={field.name}
          checked={field.state.value}
          onBlur={field.handleBlur}
          onCheckedChange={(checked: boolean | 'indeterminate') => field.handleChange(checked === true)}
          aria-invalid={isInvalid}
        />
        <FieldLabel htmlFor={field.name}>{label}</FieldLabel>
      </div>
      {description && <FieldDescription>{description}</FieldDescription>}
      {hint && <p className="text-muted-foreground text-xs">{hint}</p>}
      {isInvalid && <FieldError errors={field.state.meta.errors} />}
    </Field>
  );
}
